import { ListItem, Skeleton, Stack } from "@mui/material";

export const LoadingRow = ({ hideDivider }: { hideDivider: boolean }) => (
  <ListItem divider sx={{ borderBottom: hideDivider ? "none" : "1px solid", borderColor: "divider", height: 61 }}>
    <Stack direction="row" alignItems="center" width="100%" justifyContent="space-between" pr="20%">
      <Skeleton variant="rectangular" width={211} height={25} />
      <Skeleton variant="rectangular" width={131} height={25} />
      <Skeleton variant="rectangular" width={74} height={25} />
    </Stack>
  </ListItem>
);
